module.exports = __webpack_public_path__ + "static/media/DE.62521900.svg";